import * as React from 'react';

import { FluidSection } from 'components/FluidSection/FluidSection';
import { Calendar } from 'components/Calendar/Calendar';
import { Content } from 'components/Content/index';
import BookingFlowScreen from 'components/Dialog/BookingFlowScreen';

import FlatButton from 'material-ui/FlatButton';
import ArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';

// interface ComponentProps extends React.Props<any> {
//
// }

// interface ComponentState {

// }

// interface ReduxStateProps {

// }
  
// interface ReduxActionProps {

//}

class BookingFormView extends React.Component/*<ComponentProps & ReduxStateProps & ReduxActionProps, ComponentState>*/ {
    render(){
        const { backButtonContainerStyles, backButtonStyles, titleContainerStyles, titleContentStyles } = styles;
        return (
            <div>
                <FluidSection
                    style={ backButtonContainerStyles }
                >
                    <FlatButton
                        style={ backButtonStyles }
                        label="BACK TO CALENDAR"
                        primary={true}
                        onClick={() => this.props.onChangeViewIndex(1)}
                        disableTouchRipple={true}
                        disableFocusRipple={true}
                        icon={<ArrowLeft />}
                    />
                </FluidSection>
    
                <BookingFlowScreen
                    onChangeViewIndex={this.props.onChangeViewIndex}
                    onConfirmBooking={this.props.onConfirmBooking}
                    user={this.props.user}
                    provider={this.props.provider}
                    bookingData={this.props.bookingData}
                    handleClose={() => this.props.onChangeViewIndex(1)}
                />
            </div>
        );
    }
}

const styles = {
    titleContainerStyles: {
        marginTop: 40, 
        marginBottom: -20, 
        maxWidth: 900
    },
    titleContentStyles: {
        marginmarginBottom: 40, 
        marginRight: 40
    },
    backButtonContainerStyles: {
        marginTop: -170,
        maxWidth: 900
    },
    backButtonStyles: {
        marginLeft: 0, 
        marginTop: -50, 
        marginBottom: -50
    }
}
export default BookingFormView;


// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ServiceSalesFlow/BookingFormView.jsx